var _defs, _rect, _rect2, _path, _circle, _circle2, _circle3, _circle4, _polyline, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0d1b3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#1a3a6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e8722a"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 8,
    fill: "url(#g1)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 40,
    height: 40,
    rx: 4,
    transform: "rotate(45 32 32)",
    fill: "none",
    stroke: "rgba(255,255,255,0.12)",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 20a14 14 0 1 0 0 24",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 25,
    r: 1.4,
    fill: "rgba(255,255,255,0.6)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 30,
    r: 1.4,
    fill: "rgba(255,255,255,0.6)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 39,
    r: 1.4,
    fill: "rgba(255,255,255,0.6)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 34,
    r: 1.4,
    fill: "rgba(255,255,255,0.6)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "24,38 30,30 35,33 42,22",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.85
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "42,22 39,25 41,27",
    fill: "#fff",
    opacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.38463d300a06fd7a57839094e0e21e3d.svg";
export { ForwardRef as ReactComponent };